import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavIconData = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.25 2.1875V3.5C13.25 4.70859 10.5074 5.6875 7.125 5.6875C3.74258 5.6875 1 4.70859 1 3.5V2.1875C1 0.978906 3.74258 0 7.125 0C10.5074 0 13.25 0.978906 13.25 2.1875ZM11.7516 5.8707C12.3203 5.66836 12.8426 5.40859 13.25 5.08867V7.875C13.25 9.08359 10.5074 10.0625 7.125 10.0625C3.74258 10.0625 1 9.08359 1 7.875V5.08867C1.40742 5.41133 1.92969 5.66836 2.49844 5.8707C3.72617 6.3082 5.36133 6.5625 7.125 6.5625C8.88867 6.5625 10.5238 6.3082 11.7516 5.8707ZM1 9.46367C1.40742 9.78633 1.92969 10.0434 2.49844 10.2457C3.72617 10.6832 5.36133 10.9375 7.125 10.9375C8.88867 10.9375 10.5238 10.6832 11.7516 10.2457C12.3203 10.0434 12.8426 9.78359 13.25 9.46367V11.8125C13.25 13.0211 10.5074 14 7.125 14C3.74258 14 1 13.0211 1 11.8125V9.46367Z",
		fill: "currentColor"
	})
});
export default SvgNavIconData;
